"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchFetchRefreshToken = exports.stytchFetchSignOut = exports.stytchFetchCurrentUser = void 0;
const query_string_1 = __importDefault(require("query-string"));
const headers_1 = require("../headers");
function stytchFetchCurrentUser(accessToken, userServiceAddress) {
    const url = `${userServiceAddress}/user`;
    return fetch(url, {
        method: 'GET',
        headers: {
            ...headers_1.headers,
            Authorization: `Bearer ${accessToken}`,
        },
    });
}
exports.stytchFetchCurrentUser = stytchFetchCurrentUser;
function stytchFetchSignOut(accessToken, userServiceAddress) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/signout`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({ session_jwt: accessToken }),
    });
}
exports.stytchFetchSignOut = stytchFetchSignOut;
function stytchFetchRefreshToken(token, userServiceAddress) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/extend_jwt`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({ session_jwt: token }),
    });
}
exports.stytchFetchRefreshToken = stytchFetchRefreshToken;
